import useMediaQuery from 'Hooks/useMediaQuery';
import AppLayoutMobile from './AppLayoutMobile';
import AppLayoutDesktop from './AppLayoutDesktop';
import TrialExpiredDialog from 'Components/Organisms/TrialExpiredDialog/TrialExpiredDialog';
import ProjectBlockedDialog from 'Components/Organisms/ProjectBlockedDialog/ProjectBlockedDialog';
import SubscriptionPaymentFailedDialog from 'Components/Organisms/SubscriptionPaymentFailedDialog/SubscriptionPaymentFailedDialog.jsx';
import OnboardingModal from 'Components/Organisms/OnboardingModal/OnboardingModal';
import AppLayoutProvider from './AppLayoutProvider';

export default function AppLayout() {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    const Layout = isDesktop ? AppLayoutDesktop : AppLayoutMobile;

    return (
        <AppLayoutProvider>
            <ProjectBlockedDialog />
            <SubscriptionPaymentFailedDialog />
            <TrialExpiredDialog />
            <OnboardingModal />
            <Layout />
        </AppLayoutProvider>
    );
}
